export const testimonials = [
  {
    id: 1,
    name: 'Jessica L.',
    quote:
      "I came to Calmoras feeling completely lost and disconnected from my purpose. Through a combination of astrology readings and energy therapy, Aurora helped me clear years of stagnant energy. I finally feel like I'm living the life I was meant to live.",
    package: 'Deep Healing Journey Package',
    sign: 'Aquarius ♒',
    category: 'Energy Therapy',
    featured: true,
  },
  {
    id: 2,
    name: 'Sarah M.',
    location: 'London, UK',
    quote:
      "Calmoras gave me peace and emotional clarity when I needed it most. The chakra balancing session released tension I didn't even know I was holding.",
    sign: 'Cancer ♋',
    category: 'Chakra Healing',
  },
  {
    id: 3,
    name: 'Daniel R.',
    location: 'New York, USA',
    quote:
      'The astrology guidance was incredibly accurate and helpful. It gave me the confidence to make a major career transition I had been putting off.',
    sign: 'Virgo ♍',
    category: 'Astrology',
  },
  {
    id: 4,
    name: 'Priya S.',
    location: 'Mumbai, India',
    quote:
      'After my energy therapy session, I felt emotionally lighter and more aligned than I have in years. Aurora has a true gift.',
    sign: 'Pisces ♓',
    category: 'Energy Therapy',
  },
  {
    id: 5,
    name: 'Emma K.',
    location: 'Sydney, AUS',
    quote:
      "The most peaceful spiritual coaching I've ever experienced. The weekly sessions keep me grounded and focused on my spiritual growth.",
    sign: 'Taurus ♉',
    category: 'Coaching',
  },
  {
    id: 6,
    name: 'Marcus T.',
    location: 'Toronto, CAN',
    quote:
      'I was skeptical at first, but the birth chart reading explained so many recurring patterns in my life. Truly eye-opening.',
    sign: 'Scorpio ♏',
    category: 'Astrology',
  },
  {
    id: 7,
    name: 'Elena V.',
    location: 'Madrid, ESP',
    quote:
      'A beautiful, sacred experience. I felt a warm, comforting energy throughout the session and slept better than I have in months.',
    sign: 'Libra ♎',
    category: 'Chakra Healing',
  },
]

export const blogPosts = [
  {
    id: 1,
    title: 'Signs Your Chakras Are Blocked',
    date: 'May 10, 2026',
    excerpt:
      'Learn to recognize the physical and emotional signs that indicate your chakras need balancing and healing.',
    readTime: '5 min read',
    category: 'Healing',
  },
  {
    id: 2,
    title: 'How Aura Cleansing Works',
    date: 'May 8, 2026',
    excerpt:
      'Discover the ancient practice of aura cleansing and how it can transform your energetic field.',
    readTime: '6 min read',
    category: 'Energy',
  },
  {
    id: 3,
    title: 'Understanding Mercury Retrograde',
    date: 'May 5, 2026',
    excerpt:
      'Navigate Mercury retrograde with confidence by understanding its effects on communication and technology.',
    readTime: '8 min read',
    category: 'Astrology',
  },
  {
    id: 4,
    title: 'Benefits of Spiritual Healing',
    date: 'May 3, 2026',
    excerpt:
      'Explore the profound benefits of spiritual healing for your mind, body, and soul.',
    readTime: '4 min read',
    category: 'Wellness',
  },
  {
    id: 5,
    title: 'How Astrology Helps Life Decisions',
    date: 'May 1, 2026',
    excerpt:
      'Learn how astrology can provide clarity and guidance for important life choices.',
    readTime: '7 min read',
    category: 'Astrology',
  },
  {
    id: 6,
    title: 'Daily Energy Protection Rituals',
    date: 'April 28, 2026',
    excerpt:
      'Simple yet powerful rituals to protect your energy and maintain spiritual balance every day.',
    readTime: '5 min read',
    category: 'Rituals',
  },
]

export const faqs = [
  {
    question: 'How do online healing sessions work?',
    answer:
      'Energy healing transcends physical distance. Our sessions are conducted via secure video call, allowing you to receive healing from the comfort of your sacred space. The practitioner connects with your energy field just as effectively as in person.',
  },
  {
    question: 'What should I expect in my first session?',
    answer:
      "Your first session begins with a consultation to understand your needs. Then, you'll be guided into a relaxed state while the practitioner performs the energy work. Sensations like warmth, tingling, or emotional release are common, though some simply feel deeply relaxed.",
  },
  {
    question: 'Do I need any prior spiritual experience?',
    answer:
      'Not at all. Our services are designed for everyone, regardless of their spiritual background or experience level. Come with an open mind and heart, and we will guide you through the rest.',
  },
  {
    question: 'How long until I see results?',
    answer:
      'Many clients feel an immediate shift in their energy, feeling lighter and more peaceful right after the session. Deeper emotional or chronic issues may take a few sessions to fully resolve as layers of energy are cleared.',
  },
  {
    question: 'How do I know which service is right for me?',
    answer:
      'If you feel generally off-balance, Chakra Balancing is a great start. If you feel heavy or drained by others, Aura Cleansing is ideal. For life direction, choose Astrology. You can also book a free 15-minute discovery call to discuss your needs.',
  },
]
